import type { I18nFn } from '#/i18n/types/I18nFn';
import type { ListingType } from '#/types/ListingType';

import type { ListingRteAtsWarningType } from './types/ListingRteAtsWarningType';

export const LISTING_RTE_ATS_WARNINGS = (
  i18n: I18nFn,
  listingType: ListingType | undefined,
) =>
  ({
    EMAIL: i18n(
      `Did you mean to include an email address? Idealist won’t be able to track %(applicants)s who email you directly.`,
      {
        applicants:
          listingType === 'VOLOP' ? i18n('volunteers') : i18n('applicants'),
      },
    ),
    URL: i18n(
      `Did you mean to include a URL? Idealist won’t be able to track %(applicants)s who apply off-site.`,
      {
        applicants:
          listingType === 'VOLOP' ? i18n('volunteers') : i18n('applicants'),
      },
    ),
    BOTH: i18n(
      `Did you mean to include an email address or URL? Idealist won’t be able to track %(applicants)s who email you directly or apply off-site.`,
      {
        applicants:
          listingType === 'VOLOP' ? i18n('volunteers') : i18n('applicants'),
      },
    ),
  }) satisfies Record<ListingRteAtsWarningType, string>;
